// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1Y8IZ","additionalInfo":"AgreementModal_additionalInfo__2luT_"};